import { PersonsApiFactory } from '@mynt/backoffice-api-spec/person'
import Axios from 'api/axios'
import config from 'config'
import type { UserPrice, UserPriceRequest, UserSettingsRequest } from './api'
import {
  mapPersonLimitToUserSettings,
  mapUserPriceDtoToUserPrice,
  mapUserPriceToUserPriceRequestDto,
  mapUserSettingsRequestToPersonLimitRequest,
} from './mappers'

const personApi = PersonsApiFactory(undefined, config.boBaseUrl, Axios)

export const getUserLimit = (customerId: string) =>
  personApi.getPersonLimit(customerId).then(({ data }) => mapPersonLimitToUserSettings(data))

export const getUserPrice = (customerId: string) =>
  personApi.getPersonPrice(customerId).then(({ data }) => mapUserPriceDtoToUserPrice(data))

export const updateUserSettings = (customerId: string, userSettings: UserSettingsRequest) => {
  return personApi.updatePersonLimit(customerId, mapUserSettingsRequestToPersonLimitRequest(userSettings))
}

export const updateUserPrice = (customerId: string, userPrice: UserPriceRequest) => {
  return personApi.updatePersonPrice(customerId, mapUserPriceToUserPriceRequestDto(userPrice))
}

export const deleteUserPriceOverride = (customerId: string) => {
  return personApi.deletePersonPrice(customerId).then(({ data }) => mapUserPriceDtoToUserPrice(data))
}

export const deleteUserSettingsOverride = (customerId: string) => {
  return personApi.deletePersonLimit(customerId).then(({ data }) => mapPersonLimitToUserSettings(data))
}
